// Shared constants for practitioner/member directory forms

export const TAG_VALIDATION_MSG = "Press enter after each entry.";

// Bio & Specialties
export const PLACEHOLDER_BIO = "Write a brief biography...";
export const LABEL_BIO = "Biography";
export const PLACEHOLDER_SPECIALTIES = "Add your specialties (e.g., Anxiety, PTSD)...";
export const LABEL_SPECIALTIES = "Hypnotherapy Specialties";
export const PLACEHOLDER_EXPERIENCE = "List your experience or areas of practice...";
export const LABEL_EXPERIENCE = "Experience";
export const PLACEHOLDER_EDUCATION = "List your academic qualifications...";
export const LABEL_EDUCATION = "Education";
export const PLACEHOLDER_CERTIFICATIONS = "Mention relevant certifications...";
export const LABEL_CERTIFICATIONS = "Certifications";
export const PLACEHOLDER_MEMBERSHIPS = "List memberships in organizations...";
export const LABEL_MEMBERSHIPS = "Professional memberships";
export const PLACEHOLDER_IIH_CERTIFICATIONS = "List certifications from IIH...";
export const LABEL_IIH_CERTIFICATIONS = "Certifications from IIH";
export const PLACEHOLDER_HOURLY_RATE = "Hourly rate...";
export const LABEL_HOURLY_RATE = "Hourly Rate";

export const TAG_INPUT_FIELDS = [
  { name: "specialities", placeholder: PLACEHOLDER_SPECIALTIES, label: LABEL_SPECIALTIES },
  { name: "experience", placeholder: PLACEHOLDER_EXPERIENCE, label: LABEL_EXPERIENCE },
  { name: "education", placeholder: PLACEHOLDER_EDUCATION, label: LABEL_EDUCATION },
  { name: "certifications", placeholder: PLACEHOLDER_CERTIFICATIONS, label: LABEL_CERTIFICATIONS },
  { name: "memberships", placeholder: PLACEHOLDER_MEMBERSHIPS, label: LABEL_MEMBERSHIPS },
  { name: "instituteCertifications", placeholder: PLACEHOLDER_IIH_CERTIFICATIONS, label: LABEL_IIH_CERTIFICATIONS },
];

// Website & Socials
export const PLACEHOLDER_WEBSITE = "Enter your website URL...";
export const LABEL_WEBSITE = "Website";
export const PLACEHOLDER_LINKEDIN = "Enter your LinkedIn profile URL...";
export const LABEL_LINKEDIN = "LinkedIn";
export const PLACEHOLDER_TWITTER = "Enter your Twitter (X) profile URL...";
export const LABEL_TWITTER = "Twitter";
export const PLACEHOLDER_FACEBOOK = "Enter your facebook profile URL...";
export const LABEL_FACEBOOK = "Facebook";
export const PLACEHOLDER_INSTAGRAM = "Enter your instagram profile URL...";
export const LABEL_INSTAGRAM = "Instagram";

export const WEBSITE_SOCIALS_SECTION_TITLE = "Website & Socials";

export const WEBSITE_SOCIALS_FIELDS = [
  { name: "website", placeholder: PLACEHOLDER_WEBSITE, label: LABEL_WEBSITE, noIcon: true },
  { name: "linkedIn", placeholder: PLACEHOLDER_LINKEDIN, label: LABEL_LINKEDIN, iconKey: "LinkedIn", iconColor: "#0A66C2" },
  { name: "twitter", placeholder: PLACEHOLDER_TWITTER, label: LABEL_TWITTER, iconKey: "X", iconColor: "black" },
  { name: "fb", placeholder: PLACEHOLDER_FACEBOOK, label: LABEL_FACEBOOK, iconKey: "Facebook", iconColor: "#0A66C2" },
  { name: "instagram", placeholder: PLACEHOLDER_INSTAGRAM, label: LABEL_INSTAGRAM, iconKey: "Instagram", iconColor: "red" },
];

// Contact Info (shared)
export const PLACEHOLDER_LANGUAGES = "Add languages you speak...";
export const LABEL_LANGUAGES = "languages spoken";
export const PLACEHOLDER_PHONE = "Enter your phone number...";
export const LABEL_PHONE = "Phone";
export const PLACEHOLDER_ADDRESS = "Enter your practice or mailing address...";
export const LABEL_ADDRESS = "Address";
export const PLACEHOLDER_DESCRIPTION = "Write a brief description about yourself...";
export const LABEL_DESCRIPTION = "Description";

export const CONTACT_ROW_FIELDS = [
  { name: "languages", type: "tag", placeholder: PLACEHOLDER_LANGUAGES, label: LABEL_LANGUAGES },
  { name: "phone", type: "input", placeholder: PLACEHOLDER_PHONE, label: LABEL_PHONE, inputType: "number" },
  { name: "address", type: "input", placeholder: PLACEHOLDER_ADDRESS, label: LABEL_ADDRESS },
];

// Avatar
export const LABEL_YOUR_PICTURE = "Your Picture";
